import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@massilia/ui'

import { generateDayOptions, generateYearOptions, MONTH_OPTIONS } from '../-utils/constants'

interface BirthDateSelectFieldsProps {
  birthDay: string
  birthMonth: string
  birthYear: string
  onDayChange: (value: string) => void
  onMonthChange: (value: string) => void
  onYearChange: (value: string) => void
}

export function BirthDateSelectFields({
  birthDay,
  birthMonth,
  birthYear,
  onDayChange,
  onMonthChange,
  onYearChange,
}: BirthDateSelectFieldsProps) {
  const dayOptions = generateDayOptions(birthMonth, birthYear)
  const yearOptions = generateYearOptions()

  return (
    <div className="flex flex-col gap-2">
      <label className="text-gray-light-700 text-sm font-medium">Date de naissance</label>
      <div className="flex gap-2">
        <Select onValueChange={onDayChange} value={birthDay}>
          <SelectTrigger className="flex-1">
            <SelectValue placeholder="Jour" />
          </SelectTrigger>
          <SelectContent className="max-h-60">
            {dayOptions.map((option) => (
              <SelectItem key={option.value} value={option.value}>
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>

        <Select onValueChange={onMonthChange} value={birthMonth}>
          <SelectTrigger className="flex-1">
            <SelectValue placeholder="Mois" />
          </SelectTrigger>
          <SelectContent className="max-h-60">
            {MONTH_OPTIONS.map((option) => (
              <SelectItem key={option.value} value={option.value}>
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>

        <Select onValueChange={onYearChange} value={birthYear}>
          <SelectTrigger className="flex-1">
            <SelectValue placeholder="Année" />
          </SelectTrigger>
          <SelectContent className="max-h-60">
            {yearOptions.map((option) => (
              <SelectItem key={option.value} value={option.value}>
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  )
}
